export type UserContextTranslation = {
  waitingForBackend: string;
};

export const userContextTranslation: UserContextTranslation = {
  waitingForBackend: 'Trwa aktualizacja aplikacji. Prosimy czekać',
};
